import { SQUARE_FOOTAGE, WEIGHING_FACTOR } from "@/lib/utils";

export const COMMUNITY_NAME = "communityName";
export const METRIC_TYPE = "metricType";
export const YEAR = "year";
export const TYPE = "type";

export const METRIC_TYPE_OPTIONS = [
  {
    label: "Square Footage",
    value: SQUARE_FOOTAGE,
  },
  {
    label: "Weighing Factor",
    value: WEIGHING_FACTOR,
  }
];

export const METRIC_BEHAVIORS = [
  {
    title: "Source",
    description: "Property Master",
  },
  {
    title: "Editable",
    description: "No. Display Only",
  },
  {
    title: "Validation Rule",
    description: "Metric values are valid for distribution",
    isActive: true,
  },
];

export const METRIC_STATUS = [
  {
    label: "Rows",
    value: "0",
    key: 'totalProperties',
    className: "border-primary/20 bg-primary-300 text-primary",
    iconClassName: "bg-primary text-white",
  },
  {
    label: "Missing",
    value: "0",
    key: 'missing',
    className: "border-red-200 bg-red-50 text-red-600",
    iconClassName: "bg-red-500 text-white",
  },
  {
    label: "Total Square Footage",
    value: "0",
    key: 'totalMetricValue',
    className: "border-amber-200 bg-amber-50 text-amber-700 md:col-span-2",
    iconClassName: "bg-amber-500 text-white",
  },
];